import axios from "axios"
import {Toast} from "bootstrap"

const likeBtns = document.querySelectorAll('.update-like')

if (likeBtns.length > 0) {
    const toast = new Toast('#like-error-toast')
    likeBtns.forEach(btn => {
        btn.addEventListener('click', async () => {
            try {
                const response = await axios.post(
                    btn.dataset.updateStatusUrl,
                    {
                        csrf: btn.dataset.csrf
                    }
                )
                const numLikesSpan = btn.parentElement.querySelector('.num-likes-span')
                numLikesSpan.textContent = response.data.numLikes
                btn.dataset.updateStatusUrl = response.data.url
                if (response.data.isLiked) {
                    btn.classList.add('text-primary')
                } else {
                    btn.classList.remove('text-primary')
                }
                likeBtns.forEach(likeBtn => {
                    likeBtn.dataset.csrf = response.data.csrf
                })
                document.querySelectorAll('input[name="csrf"]').forEach(input => {
                    input.value = response.data.csrf
                })
            } catch (e) {
                toast.show()
            }
        })
    })
}

